import React from "react";
import { Zap, RefreshCw, Target } from "lucide-react";

function Default(props: { maincard: JSX.Element }) {
    const { maincard } = props;
    return (
        <div className="min-h-screen w-full flex">
            <div className="flex flex-col md:flex-row w-full min-h-screen">

                {/* Left Side */}
                <div className="hidden md:flex flex-col justify-between bg-gray-50 border-r border-gray-200 w-1/2 px-12 py-12">

                    {/* Top: Wordmark + headline */}
                    <div className="space-y-8">
                        <div className="flex items-center gap-2">
                            <span className="text-gray-900 font-semibold text-base tracking-tight">DuckFlow</span>
                        </div>

                        <div className="space-y-4">
                            <h2 className="text-4xl font-semibold tracking-tight text-gray-900 leading-[1.2]">
                                Le bon restaurant.<br />
                                Au bon moment.<br />
                                <span className="text-indigo-600">Chaque jour.</span>
                            </h2>
                            <p className="text-[15px] text-gray-500 leading-relaxed max-w-[340px]">
                                DuckFlow détecte les signaux d'achat des restaurants et vous prévient exactement quand contacter, avant vos concurrents.
                            </p>
                        </div>
                    </div>

                    {/* Middle: Top 3 features */}
                    <div className="flex-1 flex flex-col justify-center py-8 space-y-6">
                        <Feature
                            icon={<Zap className="h-5 w-5 text-indigo-600" />}
                            title="Signaux d'achat en temps réel"
                            desc="Chaque événement détecté devient une fenêtre d'opportunité sur laquelle agir immédiatement."
                        />
                        <Feature
                            icon={<RefreshCw className="h-5 w-5 text-indigo-600" />}
                            title="Base rafraîchie chaque matin"
                            desc="Mis à jour quotidiennement. Plus d'établissement fermé et de contact périmé dans votre pipeline."
                        />
                        <Feature
                            icon={<Target className="h-5 w-5 text-indigo-600" />}
                            title="Priorité aux restaurants prêts à acheter"
                            desc="Un contexte de contact clair pour chaque signal : pourquoi contacter, que proposer, et comment se différencier."
                        />
                    </div>
                </div>

                {/* Right Side: Auth form */}
                <div className="w-full md:w-1/2 flex items-center justify-center px-10 py-12 bg-white">
                    <div className="w-full max-w-sm">{maincard}</div>
                </div>
            </div>
        </div>
    );
}

function Feature({ icon, title, desc }: { icon: React.ReactNode; title: string; desc: string }) {
    return (
        <div className="flex items-start gap-4">
            <div className="w-9 h-9 bg-indigo-50 border border-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                {icon}
            </div>
            <div className="max-w-[480px]">
                <p className="text-sm font-semibold text-gray-900 mb-1">{title}</p>
                <p className="text-sm text-gray-500 leading-relaxed">{desc}</p>
            </div>
        </div>
    );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Stat({ value, label }: { value: string; label: string }) {
    return (
        <div>
            <p className="text-gray-900 font-semibold text-sm leading-none">{value}</p>
            <p className="text-gray-400 text-xs mt-1">{label}</p>
        </div>
    );
}

export default Default;
